module.exports = __webpack_public_path__ + "img/34.ebd96c15.jpg";